import * as React from 'react';
import { useEffect } from 'react';
import { connect } from 'react-redux';

import OrganizationBilling from 'modules/organizations/components/organization-billing/OrganizationBilling';
import BaseInfluencerAgencyPage from 'modules/influencers-agency/pages/BaseInfluencerAgencyPage';

import { fetchInfluencersAgency } from 'modules/influencers-agency/reducers/influencers-agencies-reducer';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('../influencers-agencies-pages.i18n.json'));

import { InfluencersAgency, Organization, Params } from 'types';

type OwnProps = {
  params: Params
};

type StateProps = {
  agency: InfluencersAgency,
  organizations: {
    [x: number]: Organization
  }
};

type DispatchProps = {
  dispatchFetchInfluencersAgency: (agencyId: number) => Promise<void>
};

type Props = OwnProps & StateProps & DispatchProps;

const InfluencersAgencyBusinessDetailsPage = ({
  params,
  organizations,
  agency,
  dispatchFetchInfluencersAgency
}: Props) => {
  const agencyId = Number(params.id);

  useEffect(() => {
    dispatchFetchInfluencersAgency(agencyId);
  }, []);

  const organization = agency && agency.organizationId ? organizations[agency.organizationId] : null;
  return (
    <BaseInfluencerAgencyPage
      agencyId={agencyId}
      documentTitle={__t('influencers_agencies_pages.business_details_heading')}
    >
      {organization &&
        <OrganizationBilling
          currentOrganization={organization}
          organizationType="agency"
        />
      }
    </BaseInfluencerAgencyPage>
  );
};

const mapStateToProps = ({ organizations, influencersAgency }): StateProps => ({
  organizations: organizations.mapByOrganizationId,
  agency: influencersAgency.profile
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchFetchInfluencersAgency: (agencyId: number) => dispatch(fetchInfluencersAgency(agencyId))
});

export default connect(mapStateToProps, mapDispatchToProps)(InfluencersAgencyBusinessDetailsPage);
